import api from 'api'

import { PrescricaoDigitalInvalidarInput } from '../modal/prescricao-digital/model-prescricaoDigital'

export const invalidarPrescricaoDigital = (input: PrescricaoDigitalInvalidarInput) => {
  return api.prescricaoDigital.invalidarPrescricaoDigital(input)
}
